import React, { useState } from 'react'
import { Button } from '../../lib/ui/button'
import AylaResponseScrollArea from '../ShortCourses/AylaResponseScrollArea'
import SavedStatusIcon from '../shared/SavedStatusIcon'
import AylaLoading from '../shared/AylaLoading'
import AylaTimeoutError, { aylaPost } from '../shared/AylaTimeout'
import useTranslation, {
  TranslationProvider,
} from '../shared/TranslationProvider'
import translations from './locales.json'

const MemoryHookSuggestions = (props) => {
  const { locale } = props
  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope={'javascript.components.PersonalBrand.MemoryHookSuggestions'}
    >
      <MemoryHookSuggestionsInner {...props} />
    </TranslationProvider>
  )
}

const MemoryHookSuggestionsInner = (props) => {
  const { t } = useTranslation()
  const { documentId, ctaText, userTargetRole } = props
  const [submitted, setSubmitted] = useState(false)
  const [targetRole, setTargetRole] = useState(userTargetRole)
  const [typingComplete, setTypingComplete] = useState(false)
  const [displayedText, setDisplayedText] = useState('')
  const [index, setIndex] = useState(0)
  const [aylaResponse, setAylaResponse] = useState(null)
  const [loadingStatus, setLoadingStatus] = useState(null)
  const showCursor = submitted && displayedText.length <= 0

  const prompt = `Write 3 sample memory hook sentences that could be used in a personal pitch statement for a ${targetRole}. The memory hook should be creative, humorous, and memorable to make the person stand out. Separate each memory hook with line breaks.`

  const requestAylaStatement = async () => {
    const url = `/personal_brand/create_ai_response?document_id=${documentId}`
    setDisplayedText('')
    setAylaResponse(null)
    setIndex(0)
    const data = { ayla_prompt: { prompt } }
    try {
      const res = await aylaPost(url, data)
      setAylaResponse(res.data.ayla_response)
      setLoadingStatus('complete')
    } catch {
      setLoadingStatus('failed')
    }
  }

  const handleButtonClick = () => {
    if (targetRole) {
      setSubmitted(true)
      setTypingComplete(false)
      requestAylaStatement()
      setLoadingStatus('loading')
    }
  }

  return (
    <div>
      <div className="mb-4 flex items-end justify-between rounded-[8px] border border-[#D3D3D3] bg-[#F7FAFC] p-3">
        <fieldset>
          <div className="flex flex-col">
            <label htmlFor="target_role">{t('my_target_role')}</label>
            <input
              id="target_role"
              defaultValue={userTargetRole}
              onChange={(e) => setTargetRole(e.target.value)}
            />
          </div>
        </fieldset>
        <Button
          disabled={submitted && !typingComplete}
          onClick={handleButtonClick}
        >
          {ctaText}
          <SavedStatusIcon loadingStatus={loadingStatus} />
        </Button>
      </div>
      {loadingStatus === 'loading' && (
        <div className="flex items-center justify-center">
          <AylaLoading />
        </div>
      )}
      {loadingStatus === 'failed' && (
        <AylaTimeoutError onRetry={handleButtonClick} />
      )}
      {loadingStatus === 'complete' && (
        <AylaResponseScrollArea
          showBorder={submitted}
          showCursor={showCursor}
          aylaResponse={aylaResponse}
          typingComplete={typingComplete}
          setTypingComplete={setTypingComplete}
          displayedText={displayedText}
          setDisplayedText={setDisplayedText}
          index={index}
          setIndex={setIndex}
          className="mb-4 h-60"
        />
      )}
      {submitted && (
        <div className="mb-4">{t('if_one_of_these_suggestions')}</div>
      )}
    </div>
  )
}
export default MemoryHookSuggestions
